module.exports = __webpack_public_path__ + "1.5.0-unryo/img/solr.f453ed60.svg";